module.exports = __webpack_public_path__ + "static/media/logo.e685056e.png";